/**
 * Sort `items` by a stored list of keys (e.g. a tenant's saved element order).
 * Items whose key is in `order` come first, in that order; items not present
 * (new/unknown keys) keep their original relative position at the end. Returns
 * the input unchanged when there is no stored order.
 */
export function orderByKeys<T>(
  items: T[],
  keyOf: (item: T) => string,
  order: string[] | undefined | null
): T[] {
  if (!order?.length) {
    return items;
  }
  const rank = new Map(order.map((key, index) => [key, index]));
  const rankOf = (item: T): number =>
    rank.get(keyOf(item)) ?? Number.MAX_SAFE_INTEGER;
  return [...items].sort((a, b) => rankOf(a) - rankOf(b));
}
